module.exports = __webpack_public_path__ + "img/face-sleeping.426d6a87.svg";